<template>
  <div class="video-tutorial">
    <div
      v-if="isShowCallToAction && !isViewedTutorial"
      class="video-tutorial__main"
      @click="watchTutorialFirstTime(true)"
    >
      <img src="@/assets/images/avatar-tutorial.svg" alt="" />
      <button class="video-tutorial__cta">
        <i class="fas fa-play"></i>
      </button>
      <span
        v-html="$i18nPresenter.t('watchTutorialX', {
          name: tutorialName
        })"
      >
      </span>
      <aha-icon
        class="video-tutorial_close"
        name="close"
        width="16"
        height="16"
        @click="closeBanner"
        viewBox="0 0 24 24"
      />
    </div>

    <VideoTutorialModal
      v-if="isShowVideoModal"
      @hideModal="hideModal"
      :youtubeLink="tutorialUrl"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VideoTutorialModal from '@/components-v2/presentation-editor/side-right/VideoTutorialModal.vue'
import Config from '@/config'
import utils from '@/util'
import constants from '@/constant'
import EventBus from '@/eventBus'

export default {
  components: {
    VideoTutorialModal,
  },
  data() {
    return {
      isShowTooltip: false,
      tooltipTimeout: null,
      isFirstTimeViewing: false,
      isShowVideoModal: false,
    }
  },
  computed: {
    ...mapState({
      rememberSettings: (state) => state.currentUser.rememberSettings || {},
      isShowCallToAction(state) {
        return state.slideActive.activeTab == 2
      },
      isViewedTutorial(state) {
        try {
          const viewedTutorials = this.rememberSettings.viewedTutorials || []
          if (state.slideActive.type === 'pickAnswer') {
            return viewedTutorials.includes(state.slideActive.slideType)
          }
          return viewedTutorials.includes(state.slideActive.type)
        } catch {
          return false
        }
      },
      tutorialName(state) {
        const { typeObj } = state.slideActive || {}

        return typeObj.name || ''
      },
      tutorialUrl: (state) => {
        const { typeObj } = state.slideActive || {}

        return typeObj.videoTutorialUrl || ''
      },
    }),
  },
  watch: {
    '$route.query': {
      handler(newVal) {
        if (
          (newVal.presenting || newVal.preview)
            && this.isShowVideoModal
        ) {
          this.hideModal(false)
        }
      },
      immediate: true,
    },
  },
  methods: {
    closeBanner(e) {
      e.stopPropagation()
      EventBus.$emit('show-tooltip-tutorial', true)
      this.saveUserSetting()
      utils.mixpanelTracking(
        constants.eventCategories.PRESENTATION_EDITOR,
        'Video tutorial > Close banner',
        this.$store.state.slideActive.type,
      )
    },
    watchTutorialFirstTime(isFirstTimeViewing = true) {
      this.isShowVideoModal = true

      if (isFirstTimeViewing) {
        this.isFirstTimeViewing = true

        this.$nextTick(function _() {
          this.saveUserSetting()
        })
      }

      utils.mixpanelTracking(
        constants.eventCategories.PRESENTATION_EDITOR,
        'Video tutorial > Reveal video',
        this.$store.state.slideActive.type,
      )
    },
    triggerHoverTooltip(isMouseOver = false) {
      this.isShowTooltip = isMouseOver

      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout)
      }
    },
    async saveUserSetting() {
      let typeFinal = null
      const { type } = this.$store.state.slideActive || {}
      if (type === 'pickAnswer') {
        const { slideType } = this.$store.state.slideActive || {}
        typeFinal = slideType
      } else {
        typeFinal = type
      }
      let viewedTutorials = this.rememberSettings.viewedTutorials || []

      if (!viewedTutorials.includes(typeFinal)) {
        viewedTutorials = viewedTutorials.concat(typeFinal)

        this.$store.state.currentUser.rememberSettings = {
          ...this.$store.state.currentUser.rememberSettings,
          viewedTutorials,
        }

        await this.$http.put(Config.api.updateUserSettings, {
          viewedTutorials,
        })
      }
    },
    hideModal(isTracking = true) {
      this.isShowVideoModal = false

      if (this.isFirstTimeViewing) {
        this.isShowTooltip = true
        this.isFirstTimeViewing = false

        this.$nextTick(function _() {
          this.tooltipTimeout = setTimeout(() => {
            this.isShowTooltip = false
          }, 2000)
        })
      }
      EventBus.$emit('show-tooltip-tutorial', true)

      if (isTracking) {
        utils.mixpanelTracking(
          constants.eventCategories.PRESENTATION_EDITOR,
          'Video tutorial > Close video',
          this.$store.state.slideActive.type,
        )
      }
    },
  },
}
</script>

<style lang="scss">
.tooltip-modifier-class {
  .tooltip-inner {
    font-size: 14px;
    line-height: 18px;
    padding: 7px 10px;
    transform: translateY(-4px);
  }
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.video-tutorial {
  position: relative;
  cursor: pointer;
  z-index: 8; // https://ahaslides.atlassian.net/browse/AHA-14039
  margin-top: 16px;
  @media (max-width:  $ipad-breakpoint) {
    display: none;
  }

  &__cta {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: #ff4954;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    font-size: 10px;

    &:focus {
      outline: 0;
      border: none;
    }

    &--portable {
      position: absolute;
      top: 2px;
      right: 5px;
    }
  }

  &__main {
    background-color: rgba(255, 203, 104, 0.2);
    padding: 12px 14px 12px 17px;
    margin: -16px -14px 12px -24px;
    display: flex;
    align-items: center;
    position: relative;
    .video-tutorial_close{
      position: absolute;
      top: 5px;
      right: 10px;
    }
    img {
      max-width: 100%;
      flex-shrink: 0;
    }

    button {
      margin-left: 14px;
      margin-right: 8px;
    }

    span {
      color: #282e3e;
      font-weight: 700;
      text-decoration: underline;
      flex-shrink: 1;
    }
  }
}
</style>
